import React from 'react';
import '../../styles/page-header.css';

/**
 * PageHeader - Componente de encabezado unificado para todas las páginas
 * Diseño elegante, sobrio y profesional con paleta neutral
 * 
 * @param {string} title - Título principal de la página
 * @param {string} subtitle - Subtítulo descriptivo (opcional)
 * @param {React.ReactNode} icon - Icono de la sección (opcional)
 * @param {React.ReactNode} badge - Badge o etiqueta adicional (opcional)
 * @param {React.ReactNode} actions - Botones o acciones de la derecha (opcional)
 * @param {string} variant - Variante de estilo: 'default', 'compact', 'large'
 */
const PageHeader = ({ 
  title, 
  subtitle, 
  icon, 
  badge,
  actions,
  variant = 'default',
  className = ''
}) => {
  return (
    <div className={`page-header-modern ${variant} ${className}`}>
      {/* Decorative line */}
      <div className="header-decoration">
        <div className="decoration-line decoration-primary"></div>
        <div className="decoration-line decoration-secondary"></div>
      </div>

      {/* Header Content */}
      <div className="header-content-wrapper">
        <div className="header-main-content">
          {/* Icon + Title Section */}
          <div className="title-section">
            {icon && (
              <div className="header-icon-wrapper">
                {icon}
              </div>
            )}
            
            <div className="title-text-group">
              <h1 className="header-title">
                {title}
                {badge && (
                  <span className="header-badge">{badge}</span>
                )}
              </h1>
              
              {subtitle && (
                <p className="header-subtitle">{subtitle}</p>
              )}
            </div>
          </div>

          {/* Actions Section */}
          {actions && (
            <div className="header-actions">
              {actions}
            </div>
          )}
        </div>
      </div>

      {/* Bottom Gradient Line */}
      <div className="header-bottom-line"></div>
    </div>
  );
};

export default PageHeader;

